import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Vuetify
import Vuetify from 'vuetify'
Vue.use(Vuetify)

// CSS / SCSS
import '@/assets/scss/_helpers.scss'
import '@/assets/scss/_typography.scss'
import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader

// Animate css
import 'animate.css';

// Axios
import axios from 'axios'
import VueAxios from 'vue-axios'

require('./axios/transport.js')
Vue.use(VueAxios, axios)

// Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// Vue2Editor
import Vue2Editor from "vue2-editor";
Vue.use(Vue2Editor);

// MomentJS
import moment from 'moment'
Vue.prototype.moment = moment


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
